module.exports = __webpack_public_path__ + "img/fallen_sky.6f819096.png";